import {Result} from "@/lib/model";

/**
 *
 * @param current
 * @param partial
 */
export const mergeToResults = ( current: Result[], partial: Result[], findResult: Result ) => {
    const dict: { [ key: string ]: { pos: number, result: Result } } = {};
    let found: Result | null = null;
    const keyFound = findResult.idCodes.codReg + '-' + findResult.idCodes.codProv + '-' + findResult.idCodes.codCom

    current.forEach(
        ( result, pos ) => {
            dict[ result.idCodes.codReg + '-' + result.idCodes.codProv + '-' + result.idCodes.codCom ] = { result, pos };
        }
    );

    partial.forEach(
        result => {
            const key = result.idCodes.codReg + '-' + result.idCodes.codProv + '-' + result.idCodes.codCom;

            const currFound = dict[key];

            if( !currFound ) return;

            current[currFound.pos] = {
                ...currFound.result,
                scrutinized: result.scrutinized,
                coalitions: result.coalitions,
                summary: result.summary
            };

            if( key === keyFound ) {
                found = current[currFound.pos];
            }
        }
    )

    return {results: current, found };
}